import React from 'react';
import CRUDDetailPage from '../../../shared/components/crud/CRUDDetailPage';
import { medicalStaffConfig } from '../config/index';
import { MedicalStaffService } from '../../../shared/services/medicalStaffService';

/**
 * MedicalStaffDetail - URL-based detail page for Medical Staff
 * Handles view, edit, and add modes with ID from URL params
 */
export default function MedicalStaffDetail() {
  return (
    <CRUDDetailPage
      config={medicalStaffConfig}
      service={MedicalStaffService}
    />
  );
}
